import { get, uniqueId } from "lodash";
import moment from "moment";
import AdUnit from "./adUnit";
import Company from "./company";
import Contact from "./contact";
import { DefinitionBatch, DefinitionList } from "./definition";
import Site from "./site";
import User from "./user";

export default class Campaign {
  id?: string;
  name: string;
  status: string;
  userId: string;
  user?: User;
  companyId: string;
  contactId: string;
  globalDiscount: number;
  subTotal: number;
  lineItems: LineItem[];
  company?: Company;
  contact?: Contact;
  avoid_conflicts: boolean;
  start?: string;
  end?: string;

  constructor(params?: Campaign) {
    this.id = get(params, "id", undefined);
    this.name = get(params, "name", "");
    this.status = get(params, "status", "");
    this.userId = get(params, "userId", "");
    this.companyId = get(params, "companyId", "");
    this.contactId = get(params, "contactId", "");
    this.globalDiscount = get(params, "globalDiscount", 0);
    this.lineItems = get(params, "lineItems", []);
    this.avoid_conflicts = get(params, "avoid_conflicts", false);
    this.subTotal = get(params, "subTotal", 0);
  }
}

export class CampaignFilters {
  status: string[];
  ref?: string[];
  dateRange?: string[];
  start?: DateFilter;
  end?: DateFilter;
  sort?: SortFilter;
  user_id?: string[];
  company_id?: string[];
  constructor(params?: CampaignFilters) {
    this.status = get(params, "status", []);
    this.ref = get(params, "ref", []);
  }
}

export interface DateFilter {
  date: Date;
  operator: "eq" | "neq" | "lte" | "gte";
}

export interface SortFilter {
  key: string;
  order: "asc" | "desc";
}

export class LineItem {
  id?: string;
  localId?: string;
  start: Date;
  end: Date;
  siteId: string;
  adUnitId: string;
  discount: number;
  definitionValueIds: string[];
  definitions?: DefinitionBatch[];
  banner?: Banner;
  site?: Site;
  adUnit?: AdUnit;
  definitionValues?: DefinitionList[];
  campaignId?: string;

  constructor(params?: LineItem) {
    this.id = get(params, "id", "");
    this.localId = get(params, "id", uniqueId("line-item-"));
    this.start = get(params, "start", new Date());
    this.end = get(params, "end", new Date());
    this.siteId = get(params, "siteId", "");
    this.adUnitId = get(params, "adUnitId", "");
    this.discount = get(params, "discount", 0);
    this.definitionValueIds = get(params, "definitionValueIds", []);
    this.definitions = get(params, "definitions", []);
  }

  static localSerialize = (params: any): any => {
    console.log(params);

    if (params) {
      params.id = get(params, "Id.$oid");
      params.adUnitId = get(params, "adUnitId.$oid");
      params.siteId = get(params, "siteId.$oid");
      params.campaignId = get(params, "siteId.$campaignId");
    }

    return params;
  };
}

export class LineItemVariation {
  [key: string]: string;
}

export class Banner {
  id?: string;
  source?: string;
  source_mobile?: string;
  targetUrl: string;
  bitly: string;

  constructor(params?: Banner) {
    this.id = get(params, "id", "");
    this.source = get(params, "source", "");
    this.source_mobile = get(params, "sourceMobile", "");
    this.targetUrl = get(params, "targetUrl", "");
    this.bitly = get(params, "bitly", "");
  }
}

export class BannerBatch {
  lineItemIds: string[];
  banner: Banner;

  constructor(params?: BannerBatch) {
    this.lineItemIds = get(params, "lineItemIds", []);
    this.banner = get(params, "banner", new Banner());
  }
}

export class ClientCampaignReport {
  id?: string;
  start: Date;
  end: Date;
  user_id: string;
  campaign_id: string;
  token?: string;
  show_ctr?: boolean;

  constructor(params?: ClientCampaignReport) {
    this.id = get(params, "id", "");
    this.start = get(params, "start", new Date());
    this.end = get(params, "end", new Date());
    this.token = get(params, "token", "");
    this.show_ctr = get(params, "show_ctr", true);
    this.user_id = get(params, "user_id", "");
    this.campaign_id = get(params, "campaign_id", "");
  }
}
